import { ITag } from "@fluentui/react";

export const sortTerms = (input: string, data: ITag[]): ITag[] => {
    try {
        let first: ITag[] = [];
        let others: ITag[] = [];
        const sortString: string = input?.trim()?.toLowerCase();
        if (sortString) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].name.toLowerCase().indexOf(sortString) === 0) {
                    first.push(data[i]);
                } else {
                    others.push(data[i]);
                }
            }
            first.sort(sortAtoZ);
            others.sort(sortAtoZ);
            return (first.concat(others));
        }
        else {
            return data.sort(sortAtoZ);
        }
    } catch (error) {
        console.warn(error);
    }
    return data;
}

const sortAtoZ = (a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;